import React from "react";

export default function BonusDrawMedia({ children }) {
  return <div className='bonus-draw__media'>{children}</div>;
}
